<template>
  <div class="text-center">
      <v-card>
        <v-container fluid>
          <v-row justify="center" class="col-12">
              <v-col cols="12">
                <v-icon @click="cancelForm" class="float-right">mdi-close</v-icon>
                <h1 class="text-center">{{title}}</h1>
              </v-col>
              <v-form
                ref="form"
                v-model="formValid"
                method="post"
              >
                <v-row class="col-12">
                <v-col cols="6">
                <v-text-field
                  color="primary"
                  v-model="form.name"
                  label="Název nápoje"
                  prepend-icon="mdi-form-textbox"
                  :rules="[rules.required]"
                  outlined
                  required
                ></v-text-field>
                </v-col>
                <v-col cols="6">
                <v-text-field
                  color="primary"
                  v-model="form.internalName"
                  label="Interní název nápoje"
                  prepend-icon="mdi-form-textbox"
                  :rules="[rules.required]"
                  outlined
                  required>
                </v-text-field>
                </v-col>
                  <v-col cols="6">
                    <v-select
                      color="primary"
                      label="Alergeny"
                      v-model="form.alergens"
                      :items="alergens"
                      return-object
                      :search-input.sync="search"
                      prepend-icon="mdi-pill"
                      item-text="name"
                      hide-selected
                      multiple
                      persistent-hint
                      small-chips
                      outlined
                      deletable-chips
                    ></v-select>
                  </v-col>
                  <v-col cols="6">
                <v-text-field
                  color="primary"
                  v-model="form.volume"
                  prepend-icon="mdi-cup-water"
                  label="Objem (ml)"
                  :rules="[rules.required, rules.floatNumber]"
                  outlined
                  required>
                </v-text-field>
                  </v-col>
                  <v-col cols="6">
                <v-text-field
                  color="primary"
                  v-model="form.calories"
                  prepend-icon="mdi-food"
                  label="Kalorie"
                  :rules="[rules.number, rules.required]"
                  outlined
                  required>
                </v-text-field>
                  </v-col>
                  <v-col cols="6">
                <v-select
                  color="primary"
                  label="Vyberte typ nápoje"
                  prepend-icon="mdi-format-list-bulleted"
                  :value="form.foodTypes"
                  v-model="form.foodTypes"
                  :items="foodTypes"
                  item-text="name"
                  return-object
                  :rules="[rules.required]"
                  :search-input.sync="search"
                  hide-selected
                  multiple
                  persistent-hint
                  small-chips
                  deletable-chips
                  outlined
                ></v-select>
                  </v-col>
                  <v-col cols="6">
                <v-select
                  color="primary"
                  label="Vyberte denní dobu"
                  :value="form.timeTypes"
                  v-model="form.timeTypes"
                  :items="timeTypes"
                  item-text="name"
                  return-object
                  :rules="[rules.required]"
                  :search-input.sync="search"
                  prepend-icon="mdi-clock-time-eight-outline"
                  hide-selected
                  multiple
                  persistent-hint
                  small-chips
                  deletable-chips
                  outlined
                ></v-select>
                  </v-col>
                  <v-col cols="6">
                <v-text-field
                  color="primary"
                  v-model="form.price"
                  :rules="[rules.required, rules.number]"
                  prepend-icon="mdi-cash"
                  label="Cena"
                  outlined
                  required>
                </v-text-field>
                  </v-col>
                  <v-col cols="6">
                <v-file-input
                  label="Vybrat fotografii"
                  v-model="photo"
                  counter="true"
                  :rules="[rules.maxSize(1000000)]"
                  show-size
                  outlined
                  prepend-icon="mdi-camera">
                  <template slot="append">
                    <v-icon
                      @click="showPhoto"
                      v-if="form.imageUrl"
                    >mdi-eye</v-icon>
                  </template>
                </v-file-input>
                  </v-col>

                  <v-col cols="6">
                    <v-checkbox
                      v-model="form.specialOffer"
                      label="Akční nabídka"
                    >
                    </v-checkbox>
                  </v-col>
                  <v-col cols="6">
                <v-checkbox
                  v-model="dataChecked"
                  label="Data jsou zkontrolována"
                  :rules="[rules.checked]"
                  outlined
                  required>
                </v-checkbox>
                  </v-col>
                  <v-col cols="12" class="text-right">
                <v-btn
                  :disabled="!formValid || wait"
                  color="warning"
                  @click="save"
                >
                  Zapsat
                </v-btn>
                  </v-col>
                </v-row>
              </v-form>
          </v-row>
        </v-container>
      </v-card>
    <v-dialog v-model="photoDialog">
      <v-card>
        <v-img
          :src="form.imageUrl ? `http://localhost:8000${form.imageUrl}` : null"
        ></v-img>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import rules from '../../../mixins/rules'
import { asFormString } from '../../../utils/formField'

export default {
  name: 'DrinksForm',
  mixins: [rules],
  props: ['item', 'alergens', 'foodTypes', 'timeTypes'],
  data () {
    return {
      photoDialog: false,
      formValid: true,
      wait: false,
      search: null,
      form: {
        ...this.item,
        price: asFormString(this.item.price),
        volume: asFormString(this.item.volume),
        calories: asFormString(this.item.calories)
      },
      photo: null,
      dataChecked: false
    }
  },
  computed: {
    title () {
      return this.item.name ? 'Upravit nápoj' : 'Přidat nápoj'
    }
  },
  methods: {
    cancelForm () {
      this.$emit('formCanceled')
    },
    save () {
      Object.keys(this.form).forEach(key => {
        if (typeof this.form[key] === 'string') {
          this.form[key] = this.form[key].trim()
        }
      })
      this.wait = true
      const options = {
        method: this.form.id ? 'put' : 'post',
        url: `/admin/drinks${this.form.id ? '/' + this.form.id : ''}`,
        data: this.keysToSnakeCase(this.form)
      }
      this.$http(options)
        .then(response => {
          const drinkId = response.data.id
          const drinkName = response.data.name
          if (this.photo) {
            const formData = new FormData()
            formData.append('image', this.photo, this.photo.name)
            formData.append('drink_id', drinkId)
            formData.append('name', drinkName)

            const photoOptions = {
              method: 'post',
              url: '/admin/drinks/upload',
              data: formData
            }
            this.$http(photoOptions)
              .then(() => {
                this.$emit('data-saved')
              })
              .catch(err => { console.log(err) })
          } else {
            this.$emit('data-saved')
          }
        })
        .catch(err => {
          this.wait = false
          console.log(err)
        })
    },
    showPhoto () {
      this.photoDialog = true
    }
  }
}
</script>

<style scoped>

</style>
